export function dragndrop() {
  
  var ajax_working = false;
  
  $("html").on("dragover", function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

  $("html").on("drop", function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

  $('#drop_file_area').on('dragover', function () {
    $(this).addClass('drag_over');
    return false;
  });

  $('#drop_file_area').on('dragleave', function () {
    $(this).removeClass('drag_over');
    return false;
  });
  
  $('body').on('click', '.portfolio_media_browse', function(e) {
    e.preventDefault();
    $($(this).attr('href')).click();
  });
  
  $('body').on('click', '#uploaded_file .add-new a', function(e) {
    e.preventDefault();
    $($(this).attr('href')).click();
  });
  
  function validateFile(mimeType, fileSize) {
    
    var fileExtensions = ['video/mp4', 'image/gif', 'image/jpeg', 'image/png'];
    var imageExtensions = ['image/gif', 'image/jpeg', 'image/png'];
    var videoExtensions = ['video/mp4'];
    
    if($.inArray(mimeType, fileExtensions) == -1)
      return 'Wrong file format!';
    else if(fileSize > 20000000 && $.inArray(mimeType, videoExtensions) != -1)
      return 'Video too big (max. 20MB)!';
    else if(fileSize > 10000000 && $.inArray(mimeType, imageExtensions) != -1)
      return 'Image/animation too big (max. 10MB)!';
    
    return true;
    
  }
  
  $('.portfolio-upload-popup #drop_file_area').on('drop', function (e) {
    
    $('.portfolio-upload-popup #drop_file_area .upload-error').text('');
    
    var $upload_notice = $('.portfolio-upload-popup .uploadnotice');
    var $upload_notice_header = $('.portfolio-upload-popup .uploadnotice h5');
    
    if($(this).closest('.drop-file-wrapper').hasClass('portfolio-uploaded'))
      return;
    
    e.preventDefault();
    $(this).removeClass('drag_over');
    var formData = new FormData();
    var files = e.originalEvent.dataTransfer.files;
    formData.append('action', 'upload_portfolio_file');
    for (var i = 0; i < files.length; i++) {

      var valid = validateFile(files[i]['type'], files[i].size);

      if(valid != 1) {
        $('.portfolio-upload-popup #drop_file_area .upload-error').text(valid);
        $upload_notice_header.text(valid);
        $upload_notice.addClass('show');
        setTimeout(function(){
          $upload_notice.removeClass('show');
        }, 1500);
        $(this).val('');
        return;
      }
    
      formData.append('portfolio_image[]', files[i]);
      
    }
    uploadFormData(formData);
  });
  
  
  $('body').on('change', '.portfolio-upload-popup #portfolio_media', function(e) { 
  
    $('.portfolio-upload-popup #drop_file_area .upload-error').text('');
    
    var $upload_notice = $('.portfolio-upload-popup .uploadnotice');
    var $upload_notice_header = $('.portfolio-upload-popup .uploadnotice h5');
  
    var formData = new FormData();
    var files = $(this)[0].files;
    formData.append('action', 'upload_portfolio_file');
    for (var i = 0; i < files.length; i++) {
      
      var valid = validateFile(files[i]['type'], files[i].size);

      if(valid != 1) {
        $('.portfolio-upload-popup #drop_file_area .upload-error').text(valid);
        $upload_notice_header.text(valid);
        $upload_notice.addClass('show');
        setTimeout(function(){
          $upload_notice.removeClass('show');
        }, 2000);
        $(this).val('');
        return;
      }
      
      formData.append('portfolio_image[]', files[i]);
    }
    uploadFormData(formData);
    $(this).val('');
  });
  
  $('#portfolio-edit-popup #drop_file_area').on('drop', function (e) {
    
    $('#portfolio-edit-popup #drop_file_area .upload-error').text('');
    
    var $upload_notice = $('.portfolio-upload-popup .uploadnotice');
    var $upload_notice_header = $('.portfolio-upload-popup .uploadnotice h5');
    
    if($(this).closest('.drop-file-wrapper').hasClass('portfolio-uploaded'))
      return;
    
    e.preventDefault();
    $(this).removeClass('drag_over');
    var formData = new FormData();
    var files = e.originalEvent.dataTransfer.files;
    formData.append('action', 'upload_portfolio_file');
    for (var i = 0; i < files.length; i++) {
      
      var valid = validateFile(files[i]['type'], files[i].size);

      if(valid != 1) {
        $('#portfolio-edit-popup #drop_file_area .upload-error').text(valid);
        $upload_notice_header.text(valid);
        $upload_notice.addClass('show');
        setTimeout(function(){
          $upload_notice.removeClass('show');
        }, 2000);
        $(this).val('');
        return;
      }
      
      formData.append('portfolio_image[]', files[i]);
    }
    edit_uploadFormData(formData);
  });
  
  
  $('body').on('change', '#portfolio-edit-popup #edit_portfolio_media', function(e) { 

    $('#portfolio-edit-popup #drop_file_area .upload-error').text('');
    
    var $upload_notice = $('.portfolio-upload-popup .uploadnotice');
    var $upload_notice_header = $('.portfolio-upload-popup .uploadnotice h5');

    var formData = new FormData();
    var files = $(this)[0].files;
    formData.append('action', 'upload_portfolio_file');
    for (var i = 0; i < files.length; i++) {
      
      var valid = validateFile(files[i]['type'], files[i].size);

      if(valid != 1) {
        $('#portfolio-edit-popup #drop_file_area .upload-error').text(valid);
        $upload_notice_header.text(valid);
        $upload_notice.addClass('show');
        setTimeout(function(){
          $upload_notice.removeClass('show');
        }, 2000);
        $(this).val('');
        return;
      }
      
      formData.append('portfolio_image[]', files[i]);
    }
    edit_uploadFormData(formData);
    $(this).val('');
  });

  $('body').on('keyup', '.portfolio-upload-popup #drop_file_area .portfolio-name', function(e) {

    $('.portfolio-upload-popup #uploaded_file span .portfolio-name').val($(this).val());
    
  });
  
  $('body').on('keyup', '.portfolio-upload-popup #drop_file_area .portfolio-description', function(e) {
    
    $('.portfolio-upload-popup #uploaded_file span .portfolio-description').val($(this).val());
    
  });
  
  $('body').on('change', '.portfolio-upload-popup #drop_file_area .portfolio-category', function(e) {
    
    $('.portfolio-upload-popup #uploaded_file span .portfolio-category').val($(this).find('option:selected').val());
    
  });
  
  $('body').on('change', '.portfolio-upload-popup #drop_file_area .choices.details_software :checkbox', function(e) {
  
    var selected_software = $('.portfolio-upload-popup #drop_file_area .choices.details_software :checkbox:checked').map(function() { return $(this).val() }).get();
    
    $('.portfolio-upload-popup #uploaded_file span .portfolio-software').val(selected_software);
    
  });
  
  $('body').on('keyup', '#portfolio-edit-popup #drop_file_area .portfolio-name', function(e) {

    $('#portfolio-edit-popup #uploaded_file span .portfolio-name').val($(this).val());
    
  });
  
  $('body').on('keyup', '#portfolio-edit-popup #drop_file_area .portfolio-description', function(e) {
    
    $('#portfolio-edit-popup #uploaded_file span .portfolio-description').val($(this).val());
    
  });
  
  $('body').on('change', '#portfolio-edit-popup #drop_file_area .portfolio-category', function(e) {
    
    $('#portfolio-edit-popup #uploaded_file span .portfolio-category').val($(this).find('option:selected').val());
    
  });
  
  $('body').on('change', '#portfolio-edit-popup #drop_file_area .choices.details_software :checkbox', function(e) {
  
    var selected_software = $('#portfolio-edit-popup #drop_file_area .choices.details_software :checkbox:checked').map(function() { return $(this).val() }).get();
    
    $('#portfolio-edit-popup #uploaded_file span .portfolio-software').val(selected_software);
    
  });
  

  $('body').on('click', '.portfolio-upload-popup #uploaded_file span .delete-resource', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).closest('span').remove();
    
    if($('.portfolio-upload-popup #uploaded_file span').length >= 2) {
      $('.portfolio-upload-popup #uploaded_file span:first-child').click();
      $('.portfolio-upload-popup #uploaded_file .add-new').show();
      $('.portfolio-upload-popup #uploaded_file .add-new-warning').show();
      $('.portfolio-upload-popup .action-area').hide();
      $('.portfolio-upload-popup #uploaded_file span .ordering').addClass('disabled');
    }
    else if($('.portfolio-upload-popup #uploaded_file span').length >= 1) {
      $('.portfolio-upload-popup .hideonupload').show();
      $('.portfolio-upload-popup .drop-file-wrapper').removeClass('portfolio-uploaded');
      $('.portfolio-upload-popup .drop-file-wrapper #drop_file_area').attr('data-attachment-id', "");
      $('.portfolio-upload-popup #drop_file_area video').hide();
      $('.portfolio-upload-popup #drop_file_area video source').attr('src', '');
      $('.portfolio-upload-popup #drop_file_area img.portfolio-media').hide();
      $('.portfolio-upload-popup #drop_file_area .portfolio-media').attr('src', '');
      $('.portfolio-upload-popup #drop_file_area .portfolio-name').val('');
      $('.portfolio-upload-popup #drop_file_area .portfolio-description').val('');
      
      $('.portfolio-upload-popup #drop_file_area .portfolio-category').val('motion');
      $('.portfolio-upload-popup #drop_file_area .portfolio-category-wrapper').hide();
      $('.portfolio-upload-popup #drop_file_area .choices.details_software :checkbox').prop("checked", false);
      $('.portfolio-upload-popup #drop_file_area .portfolio-software-wrapper').hide();
      $('.portfolio-upload-popup .action-area').hide();
      $('.portfolio-upload-popup #uploaded_file .add-new').hide();
      $('.portfolio-upload-popup #uploaded_file .add-new-warning').hide();
      $('.portfolio-upload-popup #uploaded_file span .ordering').addClass('disabled');
    }
    else {
      $('.portfolio-upload-popup #uploaded_file .add-new').hide();
      $('.portfolio-upload-popup #uploaded_file .add-new-warning').hide();
      $('.portfolio-upload-popup .action-area').show();
      $('.portfolio-upload-popup #uploaded_file span .ordering').removeClass('disabled');
    }
    
  });
  
  $('body').on('click', '#portfolio-edit-popup #uploaded_file span .delete-resource', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).closest('span').remove();
    
    if($('#portfolio-edit-popup #uploaded_file span').length >= 2) {
      $('#portfolio-edit-popup #uploaded_file span:first-child').click();
      $('#portfolio-edit-popup #uploaded_file .add-new').show();
      $('#portfolio-edit-popup #uploaded_file .add-new-warning').show();
      $('#portfolio-edit-popup .action-area').hide();
      $('#portfolio-edit-popup #uploaded_file span .ordering').addClass('disabled');
    }
    else if($('#portfolio-edit-popup #uploaded_file span').length >= 1) {
      $('#portfolio-edit-popup .hideonupload').show();
      $('#portfolio-edit-popup .drop-file-wrapper').removeClass('portfolio-uploaded');
      $('#portfolio-edit-popup .drop-file-wrapper #drop_file_area').attr('data-attachment-id', "");
      $('#portfolio-edit-popup #drop_file_area video').hide();
      $('#portfolio-edit-popup #drop_file_area video source').attr('src', '');
      $('#portfolio-edit-popup #drop_file_area img.portfolio-media').hide();
      $('#portfolio-edit-popup #drop_file_area .portfolio-media').attr('src', '');
      $('#portfolio-edit-popup #drop_file_area .portfolio-name').val('');
      $('#portfolio-edit-popup #drop_file_area .portfolio-description').val('');
      
      $('#portfolio-edit-popup #drop_file_area .portfolio-category').val('motion');
      $('#portfolio-edit-popup #drop_file_area .portfolio-category-wrapper').hide();
      $('#portfolio-edit-popup #drop_file_area .choices.details_software :checkbox').prop("checked", false);
      $('#portfolio-edit-popup #drop_file_area .portfolio-software-wrapper').hide();
      $('#portfolio-edit-popup .action-area').hide();
      $('#portfolio-edit-popup #uploaded_file .add-new').hide();
      $('#portfolio-edit-popup #uploaded_file .add-new-warning').hide();
      $('#portfolio-edit-popup #uploaded_file span .ordering').addClass('disabled');
    }
    else {
      $('#portfolio-edit-popup #uploaded_file .add-new').hide();
      $('#portfolio-edit-popup #uploaded_file .add-new-warning').hide();
      $('#portfolio-edit-popup .action-area').show();
      $('#portfolio-edit-popup #uploaded_file span .ordering').removeClass('disabled');
    }
    
  });
  
  $('body').on('click', '#uploaded_file span .ordering a', function(e) {
    
    e.preventDefault();
    e.stopPropagation();
    
    var elementToBeMoved = $(this).closest('.media-resource');
    
    if($(this).hasClass('next'))
      $(elementToBeMoved).insertAfter($(elementToBeMoved).next());

    else if($(this).hasClass('prev'))
      $(elementToBeMoved).insertBefore($(elementToBeMoved).prev());
    
  });

  $('body').on('click', '.portfolio-upload-popup #uploaded_file span', function(e) {
    
    e.preventDefault();
    
    if(!$(this).hasClass('add-new')) {
    
      var attachment_id = $(this).attr('data-attachment-id');
      var attachment_type = $(this).attr('data-attachment-type');
      
      $('#uploaded_file span').removeClass('active');
      $(this).addClass('active');
      
      $('#drop_file_area').attr('data-attachment-id', attachment_id);
      
      $('.portfolio-upload-popup').animate({ scrollTop: 0 }, 'fast');
      
      if(attachment_type == 'video') {
      
        $('.portfolio-upload-popup #drop_file_area img.portfolio-media').hide();
        $('.portfolio-upload-popup #drop_file_area video').show();
        $('.portfolio-upload-popup #drop_file_area video source').attr('src', $(this).find('source').attr('src'));
        $('.portfolio-upload-popup #drop_file_area video').attr('data-attachment-id', attachment_id);
        
        var vid = $('.portfolio-upload-popup .drop-file-wrapper video')[0];
        if(vid) {
          vid.load();
          vid.play();
        }
      }
      else {
        $('.portfolio-upload-popup #drop_file_area video').hide();
        $('.portfolio-upload-popup #drop_file_area img.portfolio-media').show();
        $('.portfolio-upload-popup #drop_file_area .portfolio-media').attr('src', $(this).find('img').attr('src'));
        $('.portfolio-upload-popup #drop_file_area .portfolio-media').attr('data-attachment-id', attachment_id);
      }
    
    }
      
    
  });
  
  $('body').on('click', '#portfolio-edit-popup #uploaded_file span', function(e) {
    
    e.preventDefault();
    
    if(!$(this).hasClass('add-new')) {
    
      var attachment_id = $(this).attr('data-attachment-id');
      var attachment_type = $(this).attr('data-attachment-type');
      
      $('#uploaded_file span').removeClass('active');
      $(this).addClass('active');

      $('#drop_file_area').attr('data-attachment-id', attachment_id);
      
      $('#portfolio-edit-popup').animate({ scrollTop: 0 }, 'fast');
      
      if(attachment_type == 'video') {
      
        $('#portfolio-edit-popup #drop_file_area img.portfolio-media').hide();
        $('#portfolio-edit-popup #drop_file_area video').show();
        $('#portfolio-edit-popup #drop_file_area video source').attr('src', $(this).find('source').attr('src'));
        $('#portfolio-edit-popup #drop_file_area video').attr('data-attachment-id', attachment_id);
        
        var vid = $('#portfolio-edit-popup .drop-file-wrapper video')[0];
        if(vid) {
          vid.load();
          vid.play();
        }
      }
      else {
        $('#portfolio-edit-popup #drop_file_area video').hide();
        $('#portfolio-edit-popup #drop_file_area img.portfolio-media').show();
        $('#portfolio-edit-popup #drop_file_area .portfolio-media').attr('src', $(this).find('img').attr('src'));
        $('#portfolio-edit-popup #drop_file_area .portfolio-media').attr('data-attachment-id', attachment_id);
      }
    
    }
      
    
  });

  function uploadFormData(form_data) {
    
    var $upload_notice = $('.portfolio-upload-popup .uploadnotice');
    var $upload_notice_header = $('.portfolio-upload-popup .uploadnotice h5');
    var $upload_notice_perc = $('.portfolio-upload-popup .uploadnotice h4');
    
    $.ajax({
      method: "POST",
      dataType: 'json',
      url: theme_vars.ajaxurl,
      data: form_data,
      contentType: false,
      cache: false,
      processData: false,
      beforeSend: function (response) {
        $upload_notice.addClass('show');
        $upload_notice_header.text('Uploading...');
        $upload_notice_perc.text();
        $('.portfolio-upload-popup').animate({ scrollTop: 0 }, 'fast');
      },
      xhr: function() {
        var myXhr = $.ajaxSettings.xhr();

        if ( myXhr.upload ) {
          myXhr.upload.addEventListener( 'progress', function(e) {
            if ( e.lengthComputable ) {
              var perc = ( e.loaded / e.total ) * 100;
              perc = perc.toFixed(0);
              $upload_notice_perc.text(perc+'%');
              if(perc == 100) {
                $upload_notice_header.text('Processing...');
                $upload_notice_perc.text('');
              }
            }
          }, false );
        }

        return myXhr;
      },
      success: function (response) {
        $upload_notice.removeClass('show');
        $('.portfolio-upload-popup .hideonupload').hide();
        $('.portfolio-upload-popup .drop-file-wrapper').addClass('portfolio-uploaded');
        $('.portfolio-upload-popup .drop-file-wrapper #drop_file_area').attr('data-attachment-id', response.data.attachment_id);
        
        $('.portfolio-upload-popup #drop_file_area .portfolio-name').val('');
        $('.portfolio-upload-popup #drop_file_area .portfolio-description').val('');
        $('.portfolio-upload-popup #drop_file_area .portfolio-category').val('motion');
        $('.portfolio-upload-popup #drop_file_area .choices.details_software :checkbox').prop("checked", false);
        
        if(response.data.new_portfolio_type == 'video') {
          
          $('.portfolio-upload-popup #drop_file_area img.portfolio-media').hide();
          $('.portfolio-upload-popup #drop_file_area video').show();
          $('.portfolio-upload-popup #drop_file_area video source').attr('src', response.data.new_portfolio);
          $('.portfolio-upload-popup #drop_file_area video').attr('data-attachment-id', response.data.attachment_id);
          
          var vid = $('.portfolio-upload-popup .drop-file-wrapper video')[0];
          if(vid) {
            vid.load();
            vid.play();
          }
        }
        else {
          $('.portfolio-upload-popup #drop_file_area video').hide();
          $('.portfolio-upload-popup #drop_file_area img.portfolio-media').show();
          $('.portfolio-upload-popup #drop_file_area .portfolio-media').attr('src', response.data.new_portfolio);
          $('.portfolio-upload-popup #drop_file_area .portfolio-media').attr('data-attachment-id', response.data.attachment_id);
        }
        
        $('.portfolio-upload-popup #uploaded_file .add-new').before(response.data.file_data);
        
        $('#uploaded_file span').removeClass('active');
        $('.portfolio-upload-popup #uploaded_file span[data-attachment-id="'+response.data.attachment_id+'"]').addClass('active');
        
        if($('.portfolio-upload-popup #uploaded_file span').length < 3) {
          $('.portfolio-upload-popup #uploaded_file .add-new').show();
          $('.portfolio-upload-popup #uploaded_file .add-new-warning').show();
          $('.portfolio-upload-popup .action-area').hide();
          
          $('.portfolio-upload-popup #drop_file_area .portfolio-name').hide();
          $('.portfolio-upload-popup #drop_file_area .portfolio-description').hide();
          $('.portfolio-upload-popup #drop_file_area .portfolio-category-wrapper').hide();
          $('.portfolio-upload-popup #drop_file_area .portfolio-software-wrapper').hide();
          
          $('.portfolio-upload-popup #uploaded_file span .ordering').addClass('disabled');
        }
        else {
          $('.portfolio-upload-popup #uploaded_file .add-new').hide();
          $('.portfolio-upload-popup #uploaded_file .add-new-warning').hide();
          $('.portfolio-upload-popup .action-area').show();
          
          $('.portfolio-upload-popup #drop_file_area .portfolio-name, #uploaded_file .media-resource .portfolio-name').val($('#uploaded_file .media-resource:first-child .portfolio-name').val());
          $('.portfolio-upload-popup #drop_file_area .portfolio-description, #uploaded_file .media-resource .portfolio-description').val($('#uploaded_file .media-resource:first-child .portfolio-description').val());
          
          
          if($('.portfolio-upload-popup #uploaded_file .media-resource:first-child .portfolio-category').val() != '') {
            $('.portfolio-upload-popup #drop_file_area .portfolio-category, .portfolio-upload-popup #uploaded_file .media-resource .portfolio-category').val($('#uploaded_file .media-resource:first-child .portfolio-category').val());
          }
          
          $('.portfolio-upload-popup #uploaded_file .media-resource .portfolio-software').val($('.portfolio-upload-popup #uploaded_file .media-resource:first-child .portfolio-software').val());
          
          var selected_software = $('.portfolio-upload-popup #uploaded_file .media-resource:first-child .portfolio-software').val().split(',');
          $.each(selected_software, function(i, v) {
            $('.portfolio-upload-popup #drop_file_area .choices.details_software :checkbox[value="'+v+'"]').prop("checked", true);
          });
          
          $('.portfolio-upload-popup #drop_file_area .portfolio-name').show();
          $('.portfolio-upload-popup #drop_file_area .portfolio-description').show();
          $('.portfolio-upload-popup #drop_file_area .portfolio-category-wrapper').show();
          $('.portfolio-upload-popup #drop_file_area .portfolio-software-wrapper').show();
          
          $('.portfolio-upload-popup #uploaded_file span .ordering').removeClass('disabled');
          
        }
        
      }
    });
    
  }
  
  function edit_uploadFormData(form_data) {
    
    var $upload_notice = $('#portfolio-edit-popup .uploadnotice');
    var $upload_notice_header = $('#portfolio-edit-popup .uploadnotice h5');
    var $upload_notice_perc = $('#portfolio-edit-popup .uploadnotice h4');
    
    $.ajax({
      method: "POST",
      dataType: 'json',
      url: theme_vars.ajaxurl,
      data: form_data,
      contentType: false,
      cache: false,
      processData: false,
      beforeSend: function (response) {
        $upload_notice.addClass('show');
        $upload_notice_header.text('Uploading...');
        $upload_notice_perc.text();
        $('#portfolio-edit-popup').animate({ scrollTop: 0 }, 'fast');
      },
      xhr: function() {
        var myXhr = $.ajaxSettings.xhr();

        if ( myXhr.upload ) {
          myXhr.upload.addEventListener( 'progress', function(e) {
            if ( e.lengthComputable ) {
              var perc = ( e.loaded / e.total ) * 100;
              perc = perc.toFixed(0);
              $upload_notice_perc.text(perc+'%');
              if(perc == 100) {
                $upload_notice_header.text('Processing...');
                $upload_notice_perc.text('');
              }
            }
          }, false );
        }

        return myXhr;
      },
      success: function (response) {
        $upload_notice.removeClass('show');
        $('#portfolio-edit-popup .hideonupload').hide();
        $('#portfolio-edit-popup .drop-file-wrapper').addClass('portfolio-uploaded');
        $('#portfolio-edit-popup .drop-file-wrapper #drop_file_area').attr('data-attachment-id', response.data.attachment_id);
        
        $('#portfolio-edit-popup #drop_file_area .portfolio-name').val('');
        $('#portfolio-edit-popup #drop_file_area .portfolio-description').val('');
        $('#portfolio-edit-popup #drop_file_area .portfolio-category').val('motion');
        $('#portfolio-edit-popup #drop_file_area .choices.details_software :checkbox').prop("checked", false);
        
        if(response.data.new_portfolio_type == 'video') {
          
          $('#portfolio-edit-popup #drop_file_area img.portfolio-media').hide();
          $('#portfolio-edit-popup #drop_file_area video').show();
          $('#portfolio-edit-popup #drop_file_area video source').attr('src', response.data.new_portfolio);
          $('#portfolio-edit-popup #drop_file_area video').attr('data-attachment-id', response.data.attachment_id);
          
          var vid = $('#portfolio-edit-popup .drop-file-wrapper video')[0];
          if(vid) {
            vid.load();
            vid.play();
          }
        }
        else {
          $('#portfolio-edit-popup #drop_file_area video').hide();
          $('#portfolio-edit-popup #drop_file_area img.portfolio-media').show();
          $('#portfolio-edit-popup #drop_file_area .portfolio-media').attr('src', response.data.new_portfolio);
          $('#portfolio-edit-popup #drop_file_area .portfolio-media').attr('data-attachment-id', response.data.attachment_id);
        }
        
        $('#portfolio-edit-popup #uploaded_file .add-new').before(response.data.file_data);
        
        $('#uploaded_file span').removeClass('active');
        $('#portfolio-edit-popup #uploaded_file span[data-attachment-id="'+response.data.attachment_id+'"]').addClass('active');
        
        if($('#portfolio-edit-popup #uploaded_file span').length < 3) {
          $('#portfolio-edit-popup #uploaded_file .add-new').show();
          $('#portfolio-edit-popup #uploaded_file .add-new-warning').show();
          $('#portfolio-edit-popup .action-area').hide();
          
          $('#portfolio-edit-popup #drop_file_area .portfolio-name').hide();
          $('#portfolio-edit-popup #drop_file_area .portfolio-description').hide();
          $('#portfolio-edit-popup #drop_file_area .portfolio-category-wrapper').hide();
          $('#portfolio-edit-popup #drop_file_area .portfolio-software-wrapper').hide();
          
          $('#portfolio-edit-popup #uploaded_file span .ordering').addClass('disabled');
        }
        else {
          $('#portfolio-edit-popup #uploaded_file .add-new').hide();
          $('#portfolio-edit-popup #uploaded_file .add-new-warning').hide();
          $('#portfolio-edit-popup .action-area').show();
          
          $('#portfolio-edit-popup #drop_file_area .portfolio-name, #uploaded_file .media-resource .portfolio-name').val($('#uploaded_file .media-resource:first-child .portfolio-name').val());
          $('#portfolio-edit-popup #drop_file_area .portfolio-description, #portfolio-edit-popup #uploaded_file .media-resource .portfolio-description').val($('#uploaded_file .media-resource:first-child .portfolio-description').val());
          
          
          if($('#portfolio-edit-popup #uploaded_file .media-resource:first-child .portfolio-category').val() != '') {
            $('#portfolio-edit-popup #drop_file_area .portfolio-category, #portfolio-edit-popup #uploaded_file .media-resource .portfolio-category').val($('#uploaded_file .media-resource:first-child .portfolio-category').val());
          }
          
          $('#portfolio-edit-popup #uploaded_file .media-resource .portfolio-software').val($('#portfolio-edit-popup #uploaded_file .media-resource:first-child .portfolio-software').val());
          
          var selected_software = $('#portfolio-edit-popup #uploaded_file .media-resource:first-child .portfolio-software').val().split(',');
          $.each(selected_software, function(i, v) {
            $('#portfolio-edit-popup #drop_file_area .choices.details_software :checkbox[value="'+v+'"]').prop("checked", true);
          });
          
          $('#portfolio-edit-popup #drop_file_area .portfolio-name').show();
          $('#portfolio-edit-popup #drop_file_area .portfolio-description').show();
          $('#portfolio-edit-popup #drop_file_area .portfolio-category-wrapper').show();
          $('#portfolio-edit-popup #drop_file_area .portfolio-software-wrapper').show();
          
          $('#portfolio-edit-popup #uploaded_file span .ordering').removeClass('disabled');
          
        }
        
      }
    });
    
  }
  

  $('body').on('click', '.portfolio-upload-popup .drop-file-wrapper .button-publish', function(e) {
    
    e.preventDefault();
    
    var $btn = $(this);

    $('.portfolio-upload-popup .drop-file-wrapper .required').removeClass('invalid');
    $('.portfolio-upload-popup .drop-file-wrapper .err-output').text('');
    
    var errors = 0;
    
    $('.portfolio-upload-popup #uploaded_file .media-resource input[name="portfolio-name"]').each(function() {
      
      if($(this).val() == '') {
        errors++;
        $('.portfolio-upload-popup #drop_file_area .portfolio-name').addClass('invalid');
        $('.portfolio-upload-popup').animate({ scrollTop: 0 }, 'fast');
        return;
      }
      
    });
    
    if(errors > 0)
      return;
    
   
    if($('.portfolio-upload-popup #uploaded_file .media-resource:first-child').data('attachment-type').toString() != 'image' || ($('.portfolio-upload-popup #uploaded_file .media-resource:first-child img').length && $('#uploaded_file .media-resource:first-child img').attr('src').indexOf('gif') >= 0)) {
      $('.portfolio-upload-popup .drop-file-wrapper .err-output').text('The thumbnail must be an image (png or jpeg)!');
      return;
    }
      
    
    var portfolio = []; 
    $('.portfolio-upload-popup #uploaded_file .media-resource').each(function(i, v) {
      portfolio.push({
        attachment_id: $(v).data('attachment-id'),
        attachment_type: $(v).data('attachment-type'),
        name: $(v).find('.portfolio-name').val(),
        description: $(v).find('.portfolio-description').val(),
        category: $(v).find('.portfolio-category').val(),
        software: $(v).find('.portfolio-software').val(),
      });
    });
    
    if(portfolio.length < 2) {
      $('.portfolio-upload-popup .drop-file-wrapper .err-output').text('You must upload 2 files to continue!');
    }
    
    if(ajax_working)
        return;
      
    ajax_working = true;
    
    $.ajax({
      method: "POST",
      dataType: 'json',
      url: theme_vars.ajaxurl,
      data: {
        action: 'publish_portfolio',
        portfolio: portfolio,
      },
      beforeSend: function (response) {
        $btn.text('Please wait...')
      },
      success: function (response) {
        ajax_working = false;
        location.reload();
      }
    });
  
  });
  
  $('body').on('click', '#portfolio-edit-popup .drop-file-wrapper .button-save', function(e) {
    
    e.preventDefault();
    
    var $btn = $(this);

    $('#portfolio-edit-popup .drop-file-wrapper .required').removeClass('invalid');
    $('#portfolio-edit-popup .drop-file-wrapper .err-output').text('');
    
    var errors = 0;
    
    $('#portfolio-edit-popup #uploaded_file .media-resource input[name="portfolio-name"]').each(function() {
      
      if($(this).val() == '') {
        errors++;
        $('#portfolio-edit-popup #drop_file_area .portfolio-name').addClass('invalid');
        $('#portfolio-edit-popup').animate({ scrollTop: 0 }, 'fast');
        return;
      }
      
    });
    
    if(errors > 0)
      return;
    
   
    if($('#portfolio-edit-popup #uploaded_file .media-resource:first-child').data('attachment-type').toString() != 'image' || ($('#portfolio-edit-popup #uploaded_file .media-resource:first-child img').length && $('#uploaded_file .media-resource:first-child img').attr('src').indexOf('gif') >= 0)) {
      $('#portfolio-edit-popup .drop-file-wrapper .err-output').text('The thumbnail must be an image (png or jpeg)!');
      return;
    }
      
    
    var portfolio = []; 
    $('#portfolio-edit-popup #uploaded_file .media-resource').each(function(i, v) {
      portfolio.push({
        attachment_id: $(v).data('attachment-id'),
        attachment_type: $(v).data('attachment-type'),
        name: $(v).find('.portfolio-name').val(),
        description: $(v).find('.portfolio-description').val(),
        category: $(v).find('.portfolio-category').val(),
        software: $(v).find('.portfolio-software').val(),
      });
    });
    
    if(portfolio.length < 2) {
      $('#portfolio-edit-popup .drop-file-wrapper .err-output').text('You must upload 2 files to continue!');
    }
    
    if(ajax_working)
        return;
      
    ajax_working = true;
    
    $.ajax({
      method: "POST",
      dataType: 'json',
      url: theme_vars.ajaxurl,
      data: {
        portfolio_id: $btn.data('portfolio-id'),
        action: 'save_portfolio',
        portfolio: portfolio,
      },
      beforeSend: function (response) {
        $btn.text('Please wait...')
      },
      success: function (response) {
        ajax_working = false;
        location.reload();
      }
    });
  
  });
  
  
  $('body').on('click', '#portfolio-remove-popup #btnYes', function(e) {
    
    e.preventDefault();
    
    var $btn = $(this);

    if(ajax_working)
        return;
      
    ajax_working = true;
    
    $.ajax({
      method: "POST",
      dataType: 'json',
      url: theme_vars.ajaxurl,
      data: {
        portfolio_id: $('.portfolio-edit-popup .button-delete').data('portfolio-id'),
        action: 'delete_portfolio',
      },
      beforeSend: function (response) {
        $btn.text('Please wait...')
      },
      success: function (response) {
        ajax_working = false;
        location.reload();
      }
    });
    
  });
  
  
  $('body').on('click', '#portfolio-remove-popup #btnNo', function(e) {
    
    e.preventDefault();
    $(this).closest('.portfolio-remove-popup').find('.popup-close').click();
    
  });

}


// WEBPACK FOOTER //
// ./assets/js/modules/dragndrop.js